var map = {
	"./audio-placeholder": 755,
	"./audio-placeholder.png": 755,
	"./avatar-missing": 358,
	"./avatar-missing.png": 358,
	"./avatar-missing.svg": 985,
	"./header-missing": 378,
	"./header-missing.png": 378,
	"./soapbox-logo": 379,
	"./soapbox-logo-white": 380,
	"./soapbox-logo-white.svg": 380,
	"./soapbox-logo.svg": 379,
	"./video-placeholder": 756,
	"./video-placeholder.png": 756,
	"./void": 757,
	"./void.png": 757,
	"./web-push/web-push-icon_expand": 787,
	"./web-push/web-push-icon_expand.png": 787,
	"./web-push/web-push-icon_favourite": 788,
	"./web-push/web-push-icon_favourite.png": 788,
	"./web-push/web-push-icon_reblog": 789,
	"./web-push/web-push-icon_reblog.png": 789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984;